// 🌐 Hook personalizado para traducciones
import { useTranslation as useI18nTranslation } from 'react-i18next';
import type { SupportedLanguages } from '../i18n';

export function useTranslation() {
  const { t, i18n } = useI18nTranslation();

  const changeLanguage = (lng: SupportedLanguages) => {
    i18n.changeLanguage(lng);
  };

  const currentLanguage = i18n.language as SupportedLanguages;

  return {
    t,
    i18n,
    currentLanguage,
    changeLanguage,
  };
}

// Re-export para facilitar imports
export { useTranslation as default };
